import { Notification } from '@com-delta-idp/mnx-skymiles-shared';
import { StandardSkyMilesMedallionBannerMocks } from '@com-delta-omnichannel/aura';
import { MenuMocks } from '../../../features';
import { LandingPage } from '../models/landing-page.interfaces';

export const NotificationMocks: Notification = {
  message: 'Success! Everything went smoothly. ',
  type: 'success'
};

export const LandingPageMocks: LandingPage = {
  medallionBanner: StandardSkyMilesMedallionBannerMocks,
  menu: MenuMocks
};
